import { render, staticRenderFns } from "./wi&iidetail.vue?vue&type=template&id=b60cc756&scoped=true&"
import script from "./wi&iidetail.vue?vue&type=script&lang=js&"
export * from "./wi&iidetail.vue?vue&type=script&lang=js&"
import style0 from "./wi&iidetail.vue?vue&type=style&index=0&id=b60cc756&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60cc756",
  null
  
)

export default component.exports